import React from 'react';
import { Outlet } from 'react-router-dom';

import MapTabs from '../components/maps/MapTabs';

import '../styles/MapPage.css';

const MapPage = () => {
  return (
    <div className="map-page">
      <header className="map-page__header">
        <MapTabs />
      </header>

      <main className="map-page__content">
        <Outlet />
      </main>
    </div>
  );
};

export default MapPage;